import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-213">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-214">
            {label}
          </label>}
        <input ref={ref} className={`
            w-full rounded-lg border px-3 py-2 text-sm outline-none transition-all
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500' : 'border-gray-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500'}
            disabled:bg-gray-50 disabled:text-gray-500
            ${className}
          `} {...props} data-id="element-215" />
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-216">{error}</p>}
        {helperText && !error && <p className="mt-1 text-xs text-gray-500" data-id="element-217">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';